var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scenario)?_c('v-icon',{staticClass:"map-pin-button mr-2",attrs:{"color":_vm.isCentred ? '#209564' : '#0F2C4D',"width":"20px","height":"20px"},on:{"click":_vm.recentre}},[_vm._v("mdi-crosshairs-gps")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }